export default __webpack_public_path__ + "static/media/phanindra.220c9211.png";